module.exports = __webpack_public_path__ + "static/ticket-booking-app-cover-252d421391fe6c59aef3bcaebb51b10d.png";